// @ts-nocheck

import React, { useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

import { FreebetsIcon } from '../../assets/img/betting';
import { ModalContentSpacing, ModalFormat } from '../../constants/ui/modal';
import { getPortalRootDOMElement } from '../../DOMElements';
import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import { SwitchIconImg } from '../../styled-components/shared';
import ScaleTransitionGroup from '../../wx/animations/ScaleTransitionGroup';
import Switch from '../common/Switch';
import HelperButton from '../HelperButton';
import Modal from '../Modal';
import UserInfo from '../UserInfo';

const Wrap = styled.div`
  display: flex;
  align-items: center;

  .switch-label {
    white-space: nowrap;
  }
`;

const StyledHelperButton = styled(HelperButton)`
  margin-left: 0.4em;
  font-size: 90%;
`;

const Circle = styled.svg`
  position: absolute;
  width: 100px;
  height: 1.6em;
  stroke: ${theme.BasketFreebetHelper.circleStrokeColor};
  fill: none;
  bottom: 0.2em;
  right: 90px;
  stroke-width: 4px;
  transform: rotate(-4deg);
`;

const HelperTitle = styled.h3`
  margin: 0;
  text-align: center;
  font-weight: normal;
`;

const HelperText = styled.p`
  margin: 0;
  color: ${theme.BasketFreebetHelper.color};
  white-space: pre-line;
`;

const InnerWrap = styled.div`
  position: relative;
  margin: 0.8em 0;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const StyledUserInfo = styled(UserInfo)`
  justify-content: center;
  align-items: stretch;
  height: 3em;
`;

const FreebetsIconComponent = (props) => <SwitchIconImg {...props} src={FreebetsIcon} />;

type BasketFreebetsSwitchProps = {
  className?: string;
  isSelected: boolean;
  onToggle: (...params: unknown) => unknown;
  isDisabled: boolean;
};

const BasketFreebetsSwitch = ({ className, isSelected = false, onToggle, isDisabled }: BasketFreebetsSwitchProps) => {
  const [isHelpOpen, setIsHelpOpen] = useState(false);

  const onClick = useCallback(() => {
    if (!isDisabled) {
      onToggle(!isSelected);
    }
  }, [isDisabled, onToggle, isSelected]);

  return (
    <>
      <Wrap className={className}>
        <Switch
          PrimaryIcon={FreebetsIconComponent}
          toggled={isSelected}
          label={__('Use Freebets')}
          onToggle={onClick}
          disabled={isDisabled}
        />
        <StyledHelperButton toggled={isHelpOpen} onToggle={() => setIsHelpOpen(true)} />
      </Wrap>
      {isHelpOpen
        ? createPortal(
            <>
              <ScaleTransitionGroup>
                <Modal
                  backgroundColor={theme.BasketFreebetHelper.modalBackgroundColor}
                  closeOnEsc
                  closeOnOutsideClick
                  contentSpacing={ModalContentSpacing.SMALL}
                  format={ModalFormat.XSMALL}
                  hasBorderRadius
                  hasCloseButton
                  hasOverlay
                  onClose={() => setIsHelpOpen(false)}
                >
                  <>
                    <HelperTitle>{__('Use Freebets')}</HelperTitle>
                    <InnerWrap>
                      <StyledUserInfo bankrollFreebetValue={1000} bankrollRealValue={0.001} />
                      <Circle viewBox="0 0 100 100" preserveAspectRatio="none">
                        <circle cx="50" cy="50" r="45" />
                      </Circle>
                    </InnerWrap>
                    <HelperText>{__('!desc:FreebetHelper')}</HelperText>
                  </>
                </Modal>
              </ScaleTransitionGroup>
            </>,
            getPortalRootDOMElement(),
          )
        : null}
    </>
  );
};

export default BasketFreebetsSwitch;
